import React, { useState } from 'react';
import {
    Box,
    TextField,
    InputAdornment,
    IconButton,
    Typography,
    Button,
    Grid,
    Paper,
} from '@mui/material';

import { Visibility, VisibilityOff } from '@mui/icons-material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { resetPassword } from './api';
import { getToken } from '../../utils/utils';
import { useNavigate } from 'react-router-dom';

const passwordStrengthCheck = (password: string) => ({
    length: password.length >= 8,
    upper: /[A-Z]/.test(password),
    lower: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
    special: /[!@#$%^&*]/.test(password),
});
   const token = getToken();
   
const getStrengthText = (score: number) => {
    if (score <= 1) return 'Too Weak';
    if (score === 2) return 'Weak';
    if (score === 3) return 'Good';
    return 'Strong';
};

const ResetPassword = () => {
    const [form, setForm] = useState({
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
    });

    const [showPassword, setShowPassword] = useState({
        old: false,
        new: false,
        confirm: false,
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const toggleVisibility = (field: 'old' | 'new' | 'confirm') => {
        setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
    };

    const strength = passwordStrengthCheck(form.newPassword);
    const strengthScore = Object.values(strength).filter(Boolean).length;

    const isValid =
        form.oldPassword &&
        form.newPassword &&
        form.confirmPassword &&
        form.newPassword === form.confirmPassword &&
        strengthScore >= 4;
console.log( form.oldPassword, "isValidisValidsssss")
  const navigate = useNavigate();
  console.log(token, "toke44444444444444444n")
const handleChangessss = async () => {
  console.log("Reset Password button clicked");
   

  try {
    const response = await resetPassword(
      {
        old_pass: form.oldPassword,
        new_pass: form.newPassword,
        conf_pass: form.confirmPassword,
      },
      token
    );

    console.log("Password reset response:", response);
    
navigate(`/password-changed`);
    // handle success (e.g., show a success message)
  } catch (error) {
    console.error("Error resetting password:", error);
    // handle error (e.g., show an error message)
  }
};

    return (
        
        <Grid container component="main" sx={{ height: '100vh' }}>
            <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
                <Box
                    sx={{
                        my: 8,
                        mx: 4,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <img src="/logo-pmi.png" alt="logo" />
                    <Box sx={{ mt: 8, textAlign: 'left', width: '440px' }}>
                        <Typography variant="h4" fontWeight="bold">
                            Reset Password
                        </Typography>
                        <Typography variant="subtitle1" mb={3}>
                            Create a new password for your account
                        </Typography>

                        {/* Old Password */}
                        <Box mb={3}>
                            <Typography fontWeight={500}>Old Password*</Typography>
                            <TextField
                                fullWidth
                                variant="standard"
                                name="oldPassword"
                                type={showPassword.old ? 'text' : 'password'}
                                placeholder="Enter Old password"
                                value={form.oldPassword}
                                onChange={handleChange}
                                InputProps={{
                                    disableUnderline: true,
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={() => toggleVisibility('old')}>
                                                {showPassword.old ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                sx={{
                                    '& .MuiInputBase-root': {
                                        backgroundColor: '#F9FBFC',
                                        borderRadius: '10px',
                                        borderBottom: '2px solid #FFB8AB',
                                        paddingX: 1,
                                        paddingY: 0.5,
                                        height: '56px',
                                        marginTop: '10px',
                                    },
                                    '& .Mui-focused .MuiInputBase-root': {
                                        borderBottom: '2px solid #C8172F',
                                    },
                                }}
                            />
                        </Box>

                        {/* New Password */}
                        <Box mb={3}>
                            <Typography fontWeight={500}>New Password*</Typography>
                            <TextField
                                fullWidth
                                variant="standard"
                                name="newPassword"
                                type={showPassword.new ? 'text' : 'password'}
                                placeholder="Enter New password"
                                value={form.newPassword}
                                onChange={handleChange}
                                InputProps={{
                                    disableUnderline: true,
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={() => toggleVisibility('new')}>
                                                {showPassword.new ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                sx={{
                                    '& .MuiInputBase-root': {
                                        borderBottom: '2px solid #FFB8AB',
                                        backgroundColor: '#F9FBFC',
                                        borderRadius: '10px',
                                        padding: '10px',
                                        marginTop: '10px',
                                        height: '56px',
                                    },
                                    '& .Mui-focused .MuiInputBase-root': {
                                        borderBottom: '2px solid #C8172F',
                                    },
                                }}
                            />
                        </Box>

                        {/* Password Strength Indicator - Grayed out when confirmPassword is entered */}
                        <Box
                            mb={2}
                            sx={{
                                opacity: form.confirmPassword ? 0.5 : 1,
                                pointerEvents: form.confirmPassword ? 'none' : 'auto',
                                display: form.confirmPassword ? 'none' : 'block',
                            }}
                        >
                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Typography fontSize="13px" color="error">
                                    Strength: {getStrengthText(strengthScore)}
                                </Typography>
                                <Box display="flex" gap={0.5} mt={1}>
                                    {[...Array(5)].map((_, idx) => (
                                        <Box
                                            key={idx}
                                            sx={{
                                                width: 15,
                                                height: 3,
                                                backgroundColor:
                                                    idx < strengthScore
                                                        ? strengthScore < 3
                                                            ? 'red'
                                                            : '#4CAF50'
                                                        : '#E0E0E0',
                                                borderRadius: 2,
                                            }}
                                        />
                                    ))}
                                </Box>
                            </Box>
                            <Box mt={1} fontSize="13px" color="#555">
                                <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
                                    <li style={{ display: 'flex', alignItems: 'center', marginBottom: 5 }}>
                                        {strength.length ? (
                                            <CheckCircleIcon sx={{ color: 'green', fontSize: 20, mr: 1 }} />
                                        ) : (
                                            <CheckCircleOutlineIcon sx={{ color: '#aaa', fontSize: 20, mr: 1 }} />
                                        )}
                                        8 Characters
                                    </li>
                                    <li style={{ display: 'flex', alignItems: 'center', marginBottom: 5 }}>
                                        {strength.upper ? (
                                            <CheckCircleIcon sx={{ color: 'green', fontSize: 20, mr: 1 }} />
                                        ) : (
                                            <CheckCircleOutlineIcon sx={{ color: '#aaa', fontSize: 20, mr: 1 }} />
                                        )}
                                        1 Upper Case
                                    </li>
                                    <li style={{ display: 'flex', alignItems: 'center', marginBottom: 5 }}>
                                        {strength.lower ? (
                                            <CheckCircleIcon sx={{ color: 'green', fontSize: 20, mr: 1 }} />
                                        ) : (
                                            <CheckCircleOutlineIcon sx={{ color: '#aaa', fontSize: 20, mr: 1 }} />
                                        )}
                                        1 Lower Case
                                    </li>
                                    <li style={{ display: 'flex', alignItems: 'center', marginBottom: 5 }}>
                                        {strength.special ? (
                                            <CheckCircleIcon sx={{ color: 'green', fontSize: 20, mr: 1 }} />
                                        ) : (
                                            <CheckCircleOutlineIcon sx={{ color: '#aaa', fontSize: 20, mr: 1 }} />
                                        )}
                                        1 Special Character
                                    </li>
                                    <li style={{ display: 'flex', alignItems: 'center', marginBottom: 5 }}>
                                        {strength.number ? (
                                            <CheckCircleIcon sx={{ color: 'green', fontSize: 20, mr: 1 }} />
                                        ) : (
                                            <CheckCircleOutlineIcon sx={{ color: '#aaa', fontSize: 20, mr: 1 }} />
                                        )}
                                        1 Numerical Character
                                    </li>
                                </ul>
                            </Box>
                        </Box>

                        {/* Confirm Password */}
                        <Box mb={3} mt={3}>
                            <Typography fontWeight={500}>Confirm Password*</Typography>
                            <TextField
                                fullWidth
                                name="confirmPassword"
                                type={showPassword.confirm ? 'text' : 'password'}
                                placeholder="Confirm New password"
                                value={form.confirmPassword}
                                onChange={handleChange}
                                variant="standard"
                                InputProps={{
                                    disableUnderline: true,
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={() => toggleVisibility('confirm')}>
                                                {showPassword.confirm ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                sx={{
                                    '& .MuiInputBase-root': {
                                        backgroundColor: '#F9FBFC',
                                        borderRadius: '10px',
                                        borderBottom: '2px solid #FFB8AB',
                                        height: '56px',
                                        padding: '10px',
                                        marginTop: '10px',
                                    },
                                    '& .Mui-focused .MuiInputBase-root': {
                                        borderBottom: '2px solid #C8172F',
                                    },
                                }}
                            />
                        </Box>

                        {/* Submit Button */}
                        <Button
                            fullWidth
                            variant="contained"
                            disabled={!isValid}
                              onClick={handleChangessss} 
                            sx={{
                                backgroundColor: isValid ? '#C8172F' : '#7D7E7F',
                                color: 'white',
                                borderRadius: '8px',
                                padding: '12px',
                                fontWeight: 'bold',
                                fontSize: '14px',
                                textTransform: 'none',
                            }}
                        >
                            Reset Password
                        </Button>
                    </Box>
                </Box>
            </Grid>
        </Grid>
    );
};

export default ResetPassword